import { useCallback } from 'react';
import AccountsIcon from 'components/SvgIcons/entities/Accounts';
import { COMPANIES } from 'constants/Entities';
import Context from 'managers/Context';
import { getLiteral } from 'utils/getLiteral';
import { successToast } from 'utils/toast';
import colors from 'constants/colors';

const useCompaniesMerge = () => {
    const { dispatch, getState } = Context.store;
    const { EntityActions, EntityDetailActions, EntityListActions } = Context.actions;
    const state = getState();
    const mergeEntityDialogState = state.entity.mergeEntityDialog;
    const activeList = state.entityList.active;

    const onCloseDialog = useCallback(() => {
        dispatch(EntityActions.closeMergeEntityDialog());
    }, [EntityActions, dispatch]);

    const onMergeSuccess = useCallback(() => {
        successToast({
            text: getLiteral('success_action_ok'),
        });

        onCloseDialog();

        if (activeList === COMPANIES.entity) {
            dispatch(EntityListActions.init(COMPANIES, true, null, null, null, true, null, true));
        }

        dispatch(EntityDetailActions.refresh(COMPANIES));
    }, [onCloseDialog, activeList, dispatch, EntityListActions, EntityDetailActions]);

    return {
        entityType: COMPANIES,
        id: mergeEntityDialogState.idEntity,
        id2: mergeEntityDialogState.idEntity2,
        onMergeSuccess,
        onCloseDialog,
        iconEmpty: <AccountsIcon color={colors.grey[100]} />,
        literals: {
            labelTitleModal: 'title_merge_accounts',
            labelTitleConfirm: 'title_merge_accounts',
            labelButtonConfirm: 'action_yes_merge_accounts',
            labelConfirmModalContent: 'label_confirm_merge_account',
            labelEntity1Name: 'label_account1_merge',
            labelEntity2Name: 'label_account2_merge',
            labelSuggestDuplicates: 'label_suggest_duplicates',
            labelActionMerge: 'action_merge',
            labelActionCancel: 'action_cancel',
            labelActionBack: 'action_back',
            labelActionSelect: 'action_select',
            labelMergeDuplicates: 'label_merge_duplicates',
            labelHelpMergeDuplicates: 'help_merge_duplicates',
            labelNoAccountsToMerge: 'warning_no_accounts_to_merge',
        },
    };
};

export default useCompaniesMerge;
